module.exports = __webpack_public_path__ + "img/ruku-b.96ae7845.svg";